// Adapted from https://cdn.datatables.net/1.10.20/js/jquery.dataTables.js
const _re_escape_regex = new RegExp(
  "(\\" +
    [
      "/",
      ".",
      "*",
      "+",
      "?",
      "|",
      "(",
      ")",
      "[",
      "]",
      "{",
      "}",
      "\\",
      "$",
      "^",
      "-"
    ].join("|\\") +
    ")",
  "g"
);

function escapeRegex(val) {
  return val.replace(_re_escape_regex, "\\$1");
}

export default function createSearch(search) {
  search = escapeRegex(search);
  let reArr = (search.match(/"[^"]+"|[^ ]+/g) || [""]).map(word => {
    if (word.charAt(0) === '"') {
      let m = word.match(/^"(.*)"$/);
      if (m) {
        // Double quoted text
        word = m[1];
        return new RegExp(word, "g");
      } else {
        word = word.replace('"', "");
        return new RegExp(word, "gi");
      }
    } else {
      word = word.replace('"', "");
      return new RegExp(word, "gi");
    }
  });
  return reArr;
}
